"use client";

import { useEffect, useState } from "react";
import { PRODUCT } from "~/constants/products";

const Yotpo = () => {
    const [renderWidget, setRenderWidget] = useState(false);

    useEffect(() => {
        setRenderWidget(true);
        window.yotpoWidgetsContainer?.initWidgets?.();
    }, [renderWidget]);

    if (!renderWidget) {
        return null;
    }

    return (
        <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id="1011086"
            data-yotpo-product-id={PRODUCT.OESTRA_CREAM}
            data-yotpo-name="Oestra Bioidentical Estradiol & Progesterone Vaginal Cream"
            data-yotpo-url="https://www.innerbalance.com/product-page"
            data-yotpo-image-url="https://www.innerbalance.com/p/wp-content/uploads/2025/02/hero-2x-2.jpg"
            data-yotpo-price="199"
            data-yotpo-currency="USD"
            data-yotpo-description="A bioidentical progesterone and estradiol vaginal cream"
        ></div>
    );
};

export default Yotpo;
